import React from "react";
import "../../../css/buttons/LineLinkButton.css";

const LineLinkButton = ({ children = "SEE MORE", onClick }) => (
  <button
    type="button"
    className="bg-transparent line-link-button "
    onClick={onClick}
  >
    <span
      className="line-link-button-line bg-primary-2"
      aria-hidden="true"
    />
    <span className="line-link-button-text nav-text text-primary-2">
      {children}
    </span>
  </button>
);

export default LineLinkButton;
